import React from "react";
import VideoService from "../apis/videos";
import VideoDetail from "./VideoDetail";
import "./main.css";


class PickedContent extends React.Component {

    state = {
        videos: []
    };

    componentDidMount() {
        this.fetchVideo("5fc0eba4f1b7396784feb5c6");
        this.fetchVideo("5fc0eb58f1b7396784feb5c5");
        this.fetchVideo("5fc0eaeff1b7396784feb5c4");
    };

    async fetchVideo(id) {
        const response = await VideoService.getVideo(id);
        this.setState({videos: [...this.state.videos, response.data]});
    };


    render() {
        return (
            <div className="picked-content">
                <h3>Most Popular</h3>
                <div className="ui three column stackable grid">
                    <div className="column">
                        <VideoDetail video={this.state.videos[0]}/>
                    </div>
                    <div className="column">
                        <VideoDetail video={this.state.videos[1]}/>
                    </div>
                    <div className="column">
                        <VideoDetail video={this.state.videos[2]}/>
                    </div>
                </div>
            </div>
        )
    };
}

export default PickedContent;